export const TRIAL_NOT_STARTED_TOOLTIP = 'Your trial will start once you create your first pipeline';

export const BILLING_CYCLE_MIGRATION_LEARN_MORE_URL =
  'https://docs.hevodata.com/account-management/billing/understanding-billing-cycles/?utm_source=docs_sidebar';

export const BILLING_CYCLE_MIGRATION_BANNER_MESSAGE =
  'Hevo is updating the billing cycles. Going forward, your billing cycle will start at 12:00 AM (UTC) on the day after your subscription start date. Any Events consumed between your original subscription time and the new cycle start time will be credited to your account. No action is needed from you. ';
